import React from 'react';
import { Grid } from '@mui/material'; 
import MenuSection from './MenuSection';
import { useFilterMenu } from '../hooks/useFilterMenu';

export default function GenericMenu({ menuConfig, sectionsMap, propsRouter }) {
  const idProject = propsRouter.match?.params?.idProject;
  const filteredMenu = useFilterMenu(menuConfig, idProject);
  const orderedKeys = Object.keys(sectionsMap);
  return (
    <Grid container spacing={2}>
      {Object.entries(filteredMenu).sort(([keyA], [keyB]) => {
      return orderedKeys.indexOf(keyA) - orderedKeys.indexOf(keyB);
    }).map(([key, items]) => {
        const sectionName = sectionsMap[key] || key;
        return (
          <MenuSection
            key={key}
            arr={items}
            name={sectionName}
          />
        );
      })}
    </Grid>
  );
}